import React, { FC } from 'react';

import { Center } from '@chakra-ui/react';

import { DownIcon, RightIcon } from 'components/Icons';

interface GrantsToggleProps {
  isOpen: boolean;

  onClick(): void;
}

/**
 * The chevron that shows or hides a principal's grants. It is the only way
 * to expand a row, since a click elsewhere on the row opens the principal.
 */
export const GrantsToggle: FC<GrantsToggleProps> = props => {
  const { isOpen, onClick } = props;
  return (
    <Center
      as="button"
      type="button"
      aria-label={isOpen ? 'Hide grants' : 'Show grants'}
      aria-expanded={isOpen}
      boxSize={5}
      borderRadius={4}
      color="gray.500"
      _hover={{ bg: 'gray.50', color: 'primary' }}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
    >
      {isOpen ? <DownIcon boxSize={3} /> : <RightIcon boxSize={3} />}
    </Center>
  );
};
